module.exports = __webpack_public_path__ + "media/images/landing-find-match-2-a66509225db261509b6355712c6cb9d9.jpeg";